import {
    EditCourseLessonInput,
    NewCourseLessonInput,
} from "../../../generated/graphql";

export const getlessonId = (
    lesson: NewCourseLessonInput | EditCourseLessonInput,
): string | undefined => {
    if ("id" in lesson && lesson.id) {
        return lesson.id;
    } else if ("localKey" in lesson && lesson.localKey) {
        return lesson.localKey;
    }

    return undefined;
};
